import { useState, useEffect } from 'react'
import ItemGrid from '@/components/common-components/filter options/ItemGrid'
import { useRegions } from "@/hooks/region/useRegion"
import { useBrands } from "@/hooks/brand/useBrand"
import data from "@/components/common-components/tables/mock_data.json"
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import NewCampaignCreation from '@/components/launch-campaign/NewCampaignCreation';

export default function LaunchCampaign() {
    // console.log(data)
    const [campaignDetails, setCampaignDetails] = useState(null)
    
    const { 
        regions, 
        selectedRegion, 
        loading: regionsLoading, 
        error: regionsError,
        handleRegionSelect,
        clearRegionSelection
    } = useRegions()

    const { 
        brands, 
        selectedBrand, 
        loading: brandsLoading, 
        error: brandsError,
        handleBrandSelect,
        clearBrandSelection
    } = useBrands() 

    // Function to handle going back from brand selection to region selection
    const handleBackToRegion = () => {
        clearRegionSelection()
    }

    const handleBacktoBrand = () => {
        clearBrandSelection()
        setCampaignDetails(null)
    }
    
    const handleBackToCampaign = () => {
        setCampaignDetails(null)
    }
    
    const handleCampaignDetailsSubmit = (details) => {
        // details now includes: budget, campaignName, selectedCampaign, selectedSheetname
        setCampaignDetails(details)
    }
    
    // console.log("Campaign Details are ", campaignDetails)

    return (
        <div className='smart-page-bg launch-campaign-page pt-16 h-full min-h-screen'>
        <div className="pt-8 md:pt-12 lg:pt-16 text-center text-3xl font-medium md:text-4xl md:font-semibold text-background">Launch Campaign</div>
            {!selectedRegion ? (
                <div className='m-6 p-6 pt-3 my-8 md:m-8 md:p-8 lg:mx-20 lg:my-10 lg:px-12 border border-border rounded-2xl bg-slate-100/90'>
                    <h2 className='text-3xl mb-8 text-center font-medium text-foreground'>Select a Region</h2>
                    <ItemGrid 
                        items={regions}
                        handleItemSelect={handleRegionSelect}
                        loading={regionsLoading}
                        error={regionsError}
                        itemkey="label"
                        valuekey="value"
                        emptyMessage='No items available'
                        isBrands={false}
                        gridClassName='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 p-4 place-items-center lg:px-6'
                    />
                </div>
            ) : !selectedBrand ? (
                <div className='m-6 p-6 pt-3 my-8 md:m-8 md:p-8 lg:mx-20 lg:my-10 lg:px-12 border border-border rounded-2xl relative bg-slate-100/90'> 
                    <div className='flex flex-row items-center w-full'>                   
                        <Button 
                            variant="ghost" 
                            size="sm" 
                            className="mb-8"
                            onClick={handleBackToRegion}
                        >
                            <ArrowLeft className="" />
                        </Button>
                        <h2 className='text-3xl mb-8 text-center font-medium w-full text-foreground'>Select a Brand</h2>
                    </div>
                    <ItemGrid 
                        items={brands}
                        handleItemSelect={handleBrandSelect}
                        loading={brandsLoading}
                        error={brandsError}
                        itemkey="label"
                        valuekey='value'
                        emptyMessage='No items available'
                        isBrands={true}
                    />
                </div>
            ) : (
                <div className="sm:m-6 md:m-6 lg:m-6 max-w-7xl xl:mx-auto mb-6">
                    <NewCampaignCreation selectedRegion={selectedRegion} selectedBrand={selectedBrand} campaignDetails={campaignDetails}/>
                </div>                    
            )}
        </div>
    )
}